// extracted by mini-css-extract-plugin
export default {"container":"VideoStream_container__I+Kzg","visible":"VideoStream_visible__R9qML","video":"VideoStream_video__PWc2-"};